/* istanbul ignore file */
import { useCallback, useMemo } from 'react'

import { PAYMENT_PROVIDERS } from '@constants/paymentProviders'
import { useCheckoutComCreditCard } from '@pages/Checkout/hooks/Payment/CheckoutCom/useCheckoutComCreditCard'
import { MethodMap } from '@pages/Checkout/hooks/Payment/useBookingPayment'

export const useCheckoutComMethods = (): MethodMap => {
  const creditCard = useCheckoutComCreditCard()

  const override = useCallback(
    (method: any) => ({
      ...method,
      provider: PAYMENT_PROVIDERS.CHECKOUTCOM,
    }),
    [],
  )

  return useMemo(
    () => ({
      creditCard: override(creditCard),
    }),
    [creditCard, override],
  )
}
